import clsx from "clsx";
import styles from "./TicketProcessingView.module.scss";

export const ticketProcessingConstants = {
  EMPTY_TABLE_MSG: "No Tickets are processed yet",
  NO_TICKETS_FOUND: "No Tickets found",
  FILTER_BTN_CLASS: "filterDrawerButton",
  GENERATE_INVOICE_BTN_TEXT: "Generate Invoices",
  FILTER_BUTTON_TEXT: "Filter",
  FILTER_ICON_ALT: "open filter panel",
  USER_DETAILS_KEY: "userDetails",
  ID_VALUE_KEY: "id",
  INVOICE_ERROR_MSG: "No approved tickets available for invoice generation",
  INVOICE_ERROR_CLASSNAME: "errorMessageStyle",
};

export const TABLE_PAGESIZE_OPTIONS = [10, 25, 50, 100];

export const fieldNames = {
  DATE_RANGE: "dateRangeFilter",
};

export const ticketProcessingColumns = [
  {
    title: "Date Range",
    sorter: false,
    width: "240px",
    key: "dateRange",
    dataIndex: "dateRange",
    render: (dateRange, record) => {
      return (
        <span className="table-font-mobile">
          {record?.dateRange?.startDate && (
            <div className={styles.dateRangeContainer}>
              <span className={styles.dateWrapper}>
                {record?.dateRange?.startDate}
              </span>
              &nbsp;&nbsp;-&nbsp;&nbsp;
              <span className={styles.dateWrapper}>
                {record?.dateRange?.endDate}
              </span>
            </div>
          )}
        </span>
      );
    },
  },
  {
    title: "Customers",
    sorter: false,
    width: "140px",
    key: "customers",
    align: "center",
    dataIndex: "customers",
    render: (customers, record) => {
      return <span className="table-font-mobile">{customers}</span>;
    },
  },
  {
    title: "Jobs",
    sorter: false,
    width: "140px",
    align: "center",
    key: "jobs",
    dataIndex: "jobs",
    render: (jobs, record) => {
      return <span className="table-font-mobile">{jobs}</span>;
    },
  },
  {
    title: "Data Input",
    sorter: false,
    width: "140px",
    align: "center",
    key: "dataInput",
    dataIndex: "dataInput",
    render: (dataInput, record) => {
      return (
        <span className="table-font-mobile">
          <span
            className={clsx({
              [styles.dateInputHighlight]:
                record?.dataInput?.pendingSubmissions,
            })}
          >
            {record?.dataInput?.count}/{record?.totalCount}
          </span>
        </span>
      );
    },
  },
  {
    title: "Manager Review",
    sorter: false,
    width: "140px",
    align: "center",
    key: "managerReviewCount",
    dataIndex: "managerReviewCount",
    render: (managerReview, record) => {
      return (
        <span className="table-font-mobile">
          {record?.managerReviewCount}/{record?.totalCount}
        </span>
      );
    },
  },
  {
    title: "Approved",
    sorter: false,
    width: "140px",
    align: "center",
    key: "approvedCount",
    dataIndex: "approvedCount",
    render: (approvedCount, record) => {
      return (
        <span className="table-font-mobile">
          {record?.approvedCount}/{record?.totalCount}
        </span>
      );
    },
  },
  {
    title: "Invoiced",
    sorter: false,
    width: "140px",
    align: "center",
    key: "invoicedCount",
    dataIndex: "invoicedCount",
    render: (invoicedCount, record) => {
      return (
        <span className="table-font-mobile">
          {record?.invoicedCount}/{record?.totalCount}
        </span>
      );
    },
  },
];
